import React, { useState, useEffect } from "react";
import BUTTON from './../../components/buttons/button';
import { Row, Col, Modal } from "antd";
import { Navigate, useAsyncError, useNavigate } from "react-router-dom";


export default function Logout() {

    const [isLogout, setIsLogout] = useState();
    const [showModal, setShowModal] = useState(true);
    const navigate = useNavigate();


    if (isLogout) {
        navigate(`/login`)
        localStorage.setItem('AccessToken', '');
        localStorage.setItem('RefreshToken', '');
    }


    return (
        <>
            <Modal open={showModal} footer={false} onCancel={() => setShowModal(false)}>
                <p>آیا مطمئن هستید می خواهید خارج شوید؟</p>
                <Row gutter={20} style={{ marginTop: "25px" }}>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <BUTTON text={"خیر"} type={"cancel"} event={() => setIsLogout(false) & setShowModal(false)} />
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <BUTTON text={"بله"} type={"submit"} event={() => setIsLogout(true) & setShowModal(false)} />

                    </Col>
                </Row>
            </Modal>

        </>
    )
}